// R-F (owner): a money field never holds more than 2 decimals. Typed/pasted text -> digits + ONE '.', ',' normalised to '.', 2 decimals max, no sign.
// Leading zeros are kept as typed (the callers/API parse the number); this only blocks the third decimal and noise.
export function sanitizeMoney(text) {
  const s = String(text ?? '').replace(/,/g, '.').replace(/[^0-9.]/g, '');
  const i = s.indexOf('.');
  if (i < 0) return s;
  return s.slice(0, i) + '.' + s.slice(i + 1).replace(/\./g, '').slice(0, 2);
}
